const initialState = null;

const quoteSelected = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_QUOTE_SELECTED':
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

export default quoteSelected;
